import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { P } from "orcs-design-system";
import {
  TreeHeader,
  TreeHeaderTitle,
  TreeHeaderStatus,
} from "src/shared/TreeView/TreeView";
import useObjectiveProfileConfig from "src/commonComponents/ObjectiveProfileHeader/hooks/useObjectiveProfileConfig";
import BadgesDisplay from "src/components/BadgesDisplay";
import { OBJECTIVE_ATTRIBUTE_TYPE } from "src/consts/objectives";
import URL, { url } from "src/consts/urlPaths";

const ObjectiveTreeHeader = ({ node, onActivate, onToggle }) => {
  const history = useHistory();
  const { badgeConfig } = useObjectiveProfileConfig(node.objective);
  const treeBadgeConfig = badgeConfig?.filter(
    (b) => b.id !== OBJECTIVE_ATTRIBUTE_TYPE.STATUS
  );
  const showToggle =
    (node.children && node.children.length > 0) || node.isParentType;
  const onObjectiveClick = (objective) => {
    const goalsExplorerPath = url(
      URL.GOALS_EXPLORE,
      objective ? { id: objective.id } : {}
    );
    history.push(goalsExplorerPath);
  };

  const onClickHeader = (e) => {
    e.stopPropagation();
    if (showToggle) {
      onToggle(node, !node.toggled);
    } else {
      onActivate(node);
    }
  };

  const onClickText = (e) => {
    e.stopPropagation();

    if (node.objective || node.group) {
      onObjectiveClick(node.objective);
    }

    if (showToggle && !node.toggled) {
      onToggle(node, true);
    } else if (!showToggle) {
      onActivate(node);
    }
  };

  const paddingLeft = showToggle ? "0px" : "30px";

  return (
    <TreeHeader
      hasChildren={showToggle}
      isActive={node.active}
      onClick={onClickHeader}
    >
      <TreeHeaderTitle
        role="link"
        tabIndex={0}
        className="treeHeaderTitle"
        data-testid={node.active ? "treeheader-node-bold" : "treeheader-node"}
        hasChildren={showToggle}
        style={{ minWidth: 0, paddingLeft }}
        onClick={onClickText}
      >
        <P
          fontWeight="1"
          data-testid="treeheader-node-name"
          color={node.isPlaceholder ? "greyDark" : undefined}
          fontSize="1"
          isActive={node.active}
          {...(node.active
            ? { id: "active-node", "data-testid": "active-node-test" }
            : {})}
        >
          {node.name}
        </P>
        <TreeHeaderStatus className="treeHeaderStatus" />
      </TreeHeaderTitle>
      {node.objective && <BadgesDisplay badgeConfig={treeBadgeConfig} />}
    </TreeHeader>
  );
};

ObjectiveTreeHeader.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    active: PropTypes.bool,
    toggled: PropTypes.bool,
    children: PropTypes.any,
    isPlaceholder: PropTypes.bool,
    isParentType: PropTypes.bool,
    objective: PropTypes.object,
    group: PropTypes.object,
  }).isRequired,
  onActivate: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  hideChangeBackground: PropTypes.bool,
};

export default ObjectiveTreeHeader;
